import React, { useContext } from 'react';
import UserContext from '../../context/UserContext';
import ErrorView from './ErrorView';

function RtcError() {
    const { wording } = useContext(UserContext);
    const { WLOST_120, WLOST_121 } = wording;

    return (
        <ErrorView title={WLOST_120} message={WLOST_121} />
    );
}

export default RtcError;
